import React from 'react';

import { buildClassNames } from '../../utils';

export const Menu: React.FC<React.ComponentProps<'ul'>> = ({ className, ...props }) => {
  const classNames = buildClassNames('dropdown-menu', className);
  return <ul className={classNames} {...props} />;
};
